<template>
  <div id="app" :class="{overflow:ethereumAddress == 'pc'}" @click="handleClick">
    <!-- pc -->
    <div v-if="ethereumAddress == 'pc'">
      <Pnetwork></Pnetwork>
    </div>
    <!-- mobile    -->
    <div v-if="ethereumAddress == 'mobile'">
      <Mnetwork />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Pnetwork from "./components/message/error-network";
import Mnetwork from "./components/mobile/error-network.vue";
import { mapState } from "vuex";
export default {
  name: "app",
  data() {
    return {
      timers: null,
      test: 0,
    };
  },
  created() {
    const backend_env = (process.env.VUE_APP_SERVER_ENV || 'prod').trim();
    if (backend_env === 'dev'){
      this.$message.success('当前环境为开发环境');
    }
  },
  components: {
    Pnetwork,
    Mnetwork,
  },
  computed: {
    ...mapState(["ethereumAddress","address"]),
  },
  methods: {
    handleClick() {
      var step = this.$store.state.ShowDownMenu;
      this.$store.commit("SetShowDownMenu", ++step);
    },
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  list-style: none;
}
#app {
  position: absolute;
  //background: linear-gradient(180deg, #3c4897 0%, #ffffff 15%);
  //background: #FFFFFF;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  font-size:14px;
}
.overflow{
  overflow: hidden;
}
body {
  font-family: Arial, "Microsoft YaHei", Helvetica, sans-serif, "宋体";
}
a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}
.nodata {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nodata img {
  width: 85%;
}
.header {
  height: 60px;
  background: transparent;
  //border-bottom: 1px solid #eee;
}
</style>